module.exports = __webpack_public_path__ + "media/images/lb/777-1c5fd104e67e503f9a413791165d61cf.svg";